/**
 * Created by JackCui on 2021/4/26
 */
import Store from '../../../utils/catch-state/store'
import {updateDetailField} from '../../constants/fields'

const fieldNumberDigitsHandle = async () => {
  return {
    systemDecimalMaxDigits: (await Store.digits('getDigits').getter())?.numberDigits
  }
}

const fieldUnitPriceDigitsHandle = async () => {
  return {
    systemDecimalMaxDigits: (await Store.digits('getDigits').getter())?.unitPriceDigits
  }
}

const precisionNumber = (type) => {
  const digitalMap = {
    'number': fieldNumberDigitsHandle,
    'currency': fieldUnitPriceDigitsHandle
  }
  return digitalMap[type]()
}

export async function updateDefaultField () {
  const fields = ['number', 'currency']
  for (let v of fields) {
    updateDetailField(v, await precisionNumber(v))
  }
}
